module.exports = __webpack_public_path__ + "static/media/burger.5055be26.svg";